// #region Enums
import {
  modeEnum,
} from '@/enum/config.enum';
// #endregion
const dualYear = parseInt(STTEDRA_DUAL_YEAR, 10);
const dualPeriodStart = STTEDRA_DUAL_PERIOD_START;
const dualPeriodEnd = STTEDRA_DUAL_PERIOD_END;
const typePortal = STTEDRA_TYPE_PORTAL;
const sttedraConfigYear = parseInt(STTEDRA_CONFIG_YEAR, 10);
const STORAGE_KEY = 'productYear';

function getInitialProductYear() {
  const storedYear = sessionStorage.getItem(STORAGE_KEY);
  if (storedYear !== null && dualYear === 1) {
    return parseInt(storedYear, 10);
  }
  if ( typePortal === modeEnum.ABONO_ANUAL &&
      dualYear === 1 &&
      nowInRange(dualPeriodStart, dualPeriodEnd)
  ) {
    return sttedraConfigYear;
  }
  return new Date().getFullYear();
}

function isActiveDualYear() {
  return !!(typePortal === modeEnum.ABONO_ANUAL &&
    dualYear === 1);
}

function nowInRange(start, end) {
  const now = new Date();

  const startDate = new Date(start);
  const endDate = new Date(end);

  return now >= startDate && now <= endDate;
}
/**
 * Vuex module to manage the APP
 */

const state = () => ({
  mode: typePortal,
  dualPeriodStart: dualPeriodStart || null,
  dualPeriodEnd: dualPeriodEnd || null,
  dualYear: isActiveDualYear(),
  productYear: getInitialProductYear(),
});

const mutations = {
  /**
   * Sets the mode portal in the state.
   * @param {Object} state - Vuex state.
   * @param {string} mode - The new mode to set.
   */
  SET_MODE_PORTAL(state, mode) {
    state.mode = mode;
  },
  SET_PRODUCT_YEAR(state, year) {
    state.productYear = year;
    sessionStorage.setItem(STORAGE_KEY, year.toString());
  },
  SET_DUAL_PERIOD_START(state, date) {
    state.dualPeriodStart = date;
  },
  SET_DUAL_PERIOD_END(state, date) {
    state.dualPeriodEnd = date;
  },
};

const actions = {
  setProductYear({commit}, year) {
    commit('SET_PRODUCT_YEAR', year);
  },
  setDualPeriodStart({commit}, date) {
    commit('SET_DUAL_PERIOD_START', date);
  },
  setDualPeriodEnd({commit}, date) {
    commit('SET_DUAL_PERIOD_END', date);
  },
};

const getters = {

  /**
   * Get the current mode portal.
   * @param {Object} state - Vuex state.
   * @returns {string} - The current mode portal.
   */
  getMode(state) {
    return state.mode;
  },
  /**
   * Check if the current mode is Verano Joven.
   * @param {Object} state - Vuex state.
   * @returns {boolean} - True if the current mode is Verano Joven.
   */
  isYoungSummer(state) {
    return state.mode === modeEnum.VERANO_JOVEN;
  },
  /**
   * Check if the current mode is Abono Anual.
   * @param {Object} state - Vuex state.
   * @returns {boolean} - True if the current mode is Abono Anual.
   */
  isAnnualPass(state) {
    return state.mode === modeEnum.ABONO_ANUAL;
  },
  /**
   * Check if dual year mode is enabled.
   * @param {Object} state - Vuex state.
   * @returns {boolean} - True if dual year mode is enabled.
   */
  hasDualYear(state) {
    return !!(typePortal === modeEnum.ABONO_ANUAL &&
    dualYear === 1 &&
    state.dualPeriodStart &&
    state.dualPeriodEnd &&
    nowInRange(state.dualPeriodStart, state.dualPeriodEnd));
  },
  /**
   * Get the active product year.
   * @param {Object} state - Vuex state.
   * @returns {number} - The active product year.
   */
  getProductYear(state) {
    return state.productYear;
  },
};

const namespaced = true;

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
